import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  Select,
  Button,
  Dropdown,
  Spin,
  Col,
  Input,
  Switch,
  Strong,
  Form,
  Typography,
  message,
} from 'antd';
import {
  searchCategories,
  searchVaccines,
  addVaccination,
  addNewVaccine,
  addNewVaccineCategory,
  getPartners,
} from '../../services/api/cashless-vaccination';
import { debounce } from '../../utils';
import AddNewVaccination from './addNewVaccination';

class AddVaccination extends Component {
  constructor(props) {
    super(props);
    console.log(props, 'props');
    this.state = {
      fetchingCategory: false,
      categoryOptions: [],
      fetchingVaccine: false,
      vaccineOptions: [],
      vaccinationCategoryId: null,
      vaccineId: null,
      cost: null,
      status: null,
      addNewVaccine: false,
      addVaccineCategory: false,
      afterDays: 0,
      partnerOptions: [],
      partnerId: null,
      partnerDiscountPrice: null,
      inoculationCharge: null,
      loading: false,
    };
    this.debounceFetchCategory = debounce(this.searchCategory, 500);
    this.debounceFetchVaccine = debounce(this.searchVaccine, 500);
  }
  componentDidMount() {
    this.getAllPartners();
    this.searchCategory(' ');
  }

  getAllPartners = () => {
    getPartners()
      .then((response) => {
        console.log({ response }, '[getPartners][response]');
        const partnerOptions = response.body.data.map((ele) => ({
          key: ele.networkPartnerId,
          label: ele.networkPartnerName,
        }));
        this.setState(
          {
            partnerOptions,
          },
          () => {
            return partnerOptions;
          }
        );
      })
      .catch((err) => {
        console.log({ error: err }, '[getAllPartners][error]');
      });
  };

  searchCategory = (value) => {
    this.setState({ fetchingCategory: true });
    searchCategories(value)
      .then((response) => {
        const categoryOptions = response.body.data.map((ele) => ({
          key: ele.id,
          label: ele.name,
        }));
        this.setState(
          {
            categoryOptions,
          },
          () => {
            return categoryOptions;
          }
        );
      })
      .finally(() => {
        this.setState({
          fetchingCategory: false,
        });
      });
  };

  searchVaccine = (value) => {
    this.setState({ fetchingVaccine: true });
    if (this.state.vaccinationCategoryId === null) {
      this.setState({
        vaccineOptions: [],
        fetchingVaccine: false,
      });
      return;
    }
    searchVaccines(value, this.state.vaccinationCategoryId)
      .then((response) => {
        const vaccineOptions = response.body.data.map((el) => ({
          key: el.id,
          label: el.name,
        }));
        this.setState(
          {
            vaccineOptions,
          },
          () => {
            return vaccineOptions;
          }
        );
      })
      .finally(() => {
        this.setState({
          fetchingVaccine: false,
        });
      });
  };

  submitVaccination = () => {
    const body = {
      categoryId: this.state.vaccinationCategoryId,
      subCategoryId: this.state.vaccineId,
      cost: this.state.cost,
      status: this.state.status,
      networkCenterId: this.props.centerId,
      availabilityAfterDays: this.state.afterDays,
      partnerId: this.state.partnerId,
      partnerDiscountPrice: this.state.partnerDiscountPrice,
      inoculationCharge: this.state.inoculationCharge,
    };
    if (body) {
      this.setState({ loading: true });
      addVaccination(body)
        .then((res) => {
          console.log(res, 'res');
          if (res.body.message === 'success') {
            message.success({
              content: 'Vaccination Made Live for this Center',
              duration: 8,
            });
            this.props.handleClose();
            this.props.reload();
          }
        })
        .catch((err) => {
          console.log(err, 'err');
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    }
  };

  addVaccination = (
    name,
    vaccinationId,
    isChild,
    criteriaTextId,
    gender,
    baseVaccinePrice
  ) => {
    console.log(
      {
        vaccinationId,
        name,
        isChild,
        criteriaTextId,
        gender,
        baseVaccinePrice,
      },
      '[addVaccination]'
    );
    if ((!criteriaTextId && isChild) || isChild === null) {
      let errorMessage = '';
      if (isChild === null) {
        errorMessage = 'Child is mandatory';
      } else if (isChild && criteriaTextId === null) {
        errorMessage = 'Criteria is not selected';
      } else if (name && isChild === null && criteriaTextId === null) {
        errorMessage = 'Birth Criteria is not selected';
      }
      message.error(errorMessage, 5);
      return;
    }

    const body = {
      vaccineName: name,
      categoryId: vaccinationId,
      isChild,
      criteriaTextId,
      gender,
      baseVaccinePrice,
    };
    console.log(body, '[body]');
    if (body) {
      return addNewVaccine(body)
        .then((response) => {
          console.log(response, '[response]');
          if (response.body.message === 'success') {
            this.setState({ addNewVaccine: false });
            message.success({
              content: 'Vaccination Added Successfully',
              duration: 5,
            });
          }
        })
        .catch((err) => {
          console.log(err, 'err');
        });
    }
  };

  addVaccinationCategory = (name) => {
    console.log({ name }, '[addVaccinationCategory]');
    if (!name) {
      let errorMessage = 'Name is mandatory';
      if (!name) {
        errorMessage += ', "Name is Blank"';
      }
      message.error({
        content: errorMessage,
        duration: 5,
      });
      return;
    }
    const body = {
      vaccineName: name,
    };
    if (body) {
      return addNewVaccineCategory(body)
        .then((response) => {
          console.log(response, '[response]');
          if (response.body.message === 'success') {
            this.setState({
              addVaccineCategory: false,
            });
            message.success({
              content: 'Vaccination Category Added Successfully',
              duration: 5,
            });
            this.searchCategory(' ');
          }
        })
        .catch((err) => {
          console.log(err, 'err');
        });
    }
  };

  addInput = () => {
    this.setState({
      addNewVaccine: true,
    });
  };

  addNewVaccineCategory = () => {
    this.setState({
      addVaccineCategory: true,
    });
  };

  render() {
    const { categoryOptions, vaccineOptions, partnerOptions } = this.state;
    return (
      <>
        <Modal
          visible={this.props.modalIsOpen}
          title="Add New Vaccine For Center"
          onCancel={() => {
            this.props.handleClose();
          }}
          footer={[
            <Button
              key="cancel"
              onClick={() => {
                this.props.handleClose();
              }}
            >
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={this.state.loading}
              onClick={this.submitVaccination}
            >
              Submit
            </Button>,
          ]}
        >
          <Form
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            //   initialValues={{ remember: true }}
            //   onFinish={this.onFinish}
            //   onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item label="Select Partner" name="partnerSelect">
              <Select
                showSearch
                style={{ width: '50%', marginLeft: '10px' }}
                dropdownMatchSelectWidth={false}
                notFoundContent={partnerOptions ? <Spin size="small" /> : null}
                placeholder="Search Partner"
                defaultActiveFirstOption={true}
                filterOption={false}
                showArrow={false}
                onSearch={this.searchCategory}
                //   value={categoryName}
                onSelect={(value) => {
                  this.setState({ partnerId: value });
                }}
              >
                {partnerOptions.map((ele) => {
                  return (
                    <Select.Option key={ele.key}>
                      <Col>{ele.label}</Col>
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            {this.state.partnerId && (
              <Form.Item label="Vaccine Category" name="vaccineCategory">
                <Select
                  showSearch
                  style={{ width: '50%', marginLeft: '10px' }}
                  dropdownMatchSelectWidth={false}
                  notFoundContent={
                    categoryOptions ? <Spin size="small" /> : null
                  }
                  placeholder="Search Category"
                  defaultActiveFirstOption={true}
                  filterOption={false}
                  showArrow={false}
                  onSearch={this.searchCategory}
                  //   value={categoryName}
                  onSelect={(value) => {
                    this.setState({ vaccinationCategoryId: value });
                  }}
                >
                  {categoryOptions.map((ele) => {
                    return (
                      <Select.Option key={ele.key}>
                        <Col>{ele.label}</Col>
                      </Select.Option>
                    );
                  })}
                </Select>
                <Button className="ml-3" onClick={this.addNewVaccineCategory}>
                  +
                </Button>
              </Form.Item>
            )}
            {this.state.vaccinationCategoryId && (
              <Form.Item label="Vaccine Name" name="vaccineName">
                <Select
                  showSearch
                  style={{ width: '50%', marginLeft: '10px' }}
                  dropdownMatchSelectWidth={false}
                  notFoundContent={
                    vaccineOptions ? <Spin size="small" /> : null
                  }
                  placeholder="Search Category"
                  defaultActiveFirstOption={true}
                  filterOption={false}
                  showArrow={false}
                  onSearch={this.searchVaccine}
                  onSelect={(value) => {
                    this.setState({ vaccineId: value });
                  }}
                >
                  {vaccineOptions.map((el) => {
                    return (
                      <Select.Option key={el.key}>
                        <Col>{el.label}</Col>
                      </Select.Option>
                    );
                  })}
                </Select>
                <Button className="ml-3" onClick={this.addInput}>
                  +
                </Button>
              </Form.Item>
            )}
            <Form.Item label="Available After Days">
              <Input
                style={{ width: '50%', marginLeft: '10px' }}
                onChange={(e) => {
                  this.setState({
                    afterDays: e.target.value,
                  });
                }}
              />
            </Form.Item>
            <Form.Item label="Partner Discount Price" name="vaccineName">
              <Input
                style={{ width: '50%', marginLeft: '10px' }}
                onChange={(event) => {
                  this.setState({
                    partnerDiscountPrice: event.target.value,
                  });
                }}
              />
            </Form.Item>
            <Form.Item label="Sponsor Vaccine Cost" name="vaccineName">
              <Input
                style={{ width: '50%', marginLeft: '10px' }}
                onChange={(event) => {
                  this.setState({
                    cost: event.target.value,
                  });
                }}
              />
            </Form.Item>
            <Form.Item label="Inoculation Charge" name="inoculationCharge">
              <Input
                style={{ width: '50%', marginLeft: '10px' }}
                onChange={(event) => {
                  this.setState({
                    inoculationCharge: event.target.value,
                  });
                }}
              />
            </Form.Item>
            <Form.Item label="Vaccine Status" name="vaccineStatus">
              <Switch
                style={{ marginLeft: '10px' }}
                onChange={() => {
                  this.setState({
                    status: !this.state.status,
                  });
                }}
              />
            </Form.Item>
          </Form>
        </Modal>
        {this.state.addNewVaccine && (
          <AddNewVaccination
            modalIsOpen={this.state.addNewVaccine}
            handleClose={() => {
              this.setState({ addNewVaccine: false });
            }}
            submitApi={this.addVaccination}
            reload={() => this.fetchNetworkVaccination(this.props.centerId)}
            centerId={this.props.centerId}
            vaccinationId={this.state.vaccinationCategoryId}
            title="New Vaccine Name"
            label="Vaccine Name"
            addNewVaccine={true}
          />
        )}
        {this.state.addVaccineCategory && (
          <AddNewVaccination
            modalIsOpen={this.state.addVaccineCategory}
            handleClose={() => {
              this.setState({ addVaccineCategory: false });
            }}
            submitApi={this.addVaccinationCategory}
            title="New Category Vaccine Name"
            label="Vaccine Category Name"
            // addVaccineCategory={true}
          />
        )}
      </>
    );
  }
}

export default AddVaccination;
